import * as ACTION_CONSTS from '../constants/actions.constants';

const genericKeyValue = (
  entityName,
  fallbackReducer,
  initialState = {},
) => (state = initialState, action) => {
  if (!action.meta || (action.meta && action.meta.entity !== entityName)) {
    return state;
  }
  switch (action.type) {
    case ACTION_CONSTS.UPDATE_KEY: {
      return {
        ...state,
        ...action.payload,
      };
    }
    default:
      return state;
  }
};

export default genericKeyValue;
